// Types
import { KycHandlersBuilderType, KycHandlersType } from './types/kyc.handlers.type';
// Utils
import { checkHandleOnBackHeader } from 'utils/app-back.utils';

const KycHandlers = (props: KycHandlersBuilderType): KycHandlersType => ({
  handleOnBackHeader: () => checkHandleOnBackHeader(props),
});

export { KycHandlers };
